module.exports = __webpack_public_path__ + "img/light-grey.bac7e63b.webp";